import { app } from '../../../../../app';
import { Controller } from './sharing-center-deleted-report.controller';

app.component('sharingCenterDeletedReport', {
    bindings: {
        accounts: '<',
    },
    controller: Controller,
    templateUrl: require('./sharing-center-deleted-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.component.js